import React from "react";
import {BaseComponent} from "../../../components/BaseComponent";
import ModalComponent from "../../../containers/App/Components/Modal/Modal";
import ButtonComponent from "../../../containers/App/Components/Button/Button";

export class ProductDefaultTasksModalConfirmation extends BaseComponent {
  render() {
    return (
      <ModalComponent title={this.lbl('confirm')}>
        {this.lbl('product.details.tasks.applyDefaultTasksConfirmation')}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent
            style="ButtonSoftEdit"
            onClick={this.props.onConfirm}
          >
            {this.lbl('yes')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.props.onCancel}>
            {this.lbl('no')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}
